export enum QuizMainStep {
    EducationLevel = 'STEP_EDUCATION_LEVEL',
    Grade = 'STEP_GRADE',
    FocusIssues = 'STEP_FOCUS_ISSUES',
    DescribePerformance = 'STEP_DESCRIBE_PERFORMANCE',
    PeersConcern = 'STEP_PEERS_CONCERN',
    PriorExperience = 'STEP_PRIOR_EXPERIENCE',
    ChildFeeling = 'STEP_CHILD_FEELING',
    ChildGender = 'STEP_CHILD_GENDER',
    AdhdSymptoms = 'STEP_ADHD_SYMPTOMS',
    TypeOfSchool = 'STEP_TYPE_OF_SCHOOL',
    ChildDiscipline = 'STEP_CHILD_DISCIPLINE',
    Score = 'STEP_SCORE',
    StudyGoal = 'STEP_STUDY_GOAL',
    HowSoon = 'STEP_HOW_SOON',
    HowSociable = 'STEP_HOW_SOCIABLE',
    HandleHomework = 'STEP_HANDLE_HOMEWORK',
    CovidImpact = 'STEP_COVID_IMPACT',
    SummerLoss = 'SUMMER_LOSS',
    SummerLearning = 'STEP_SUMMER_LEARNING',
    EnjoyLearning = 'STEP_ENJOY_LEARNING',
    WantEnjoy = 'STEP_WANT_ENJOY',
    SummerChallenges = 'STEP_SUMMER_CHALLENGES',
    OutOfSchoolTutor = 'STEP_OUT_OF_SCHOOL_TUTOR',
    SeekMath = 'STEP_SEEK_MATH',
    TriedToHelp = 'STEP_TRIED_TO_HELP',
    HomeworkDifficulties = 'STEP_HOMEWORK_DIFFICULTIES',
    Zip = 'STEP_ZIP',
    EnterEmail = 'STEP_ENTER_EMAIL',
    ParentName = 'STEP_PARENT_NAME',
    PhoneNumber = 'STEP_PHONE_NUMBER',
    BookingDetails = 'STEP_BOOKING_DETAILS',
    BookingDetailsEla = 'STEP_BOOKING_DETAILS_ELA',
    ScreenAdhdLimit = 'SCREEN_ADHD_LIMIT',
    ScreenLearningLimit = 'SCREEN_LEARNING_LIMIT',
    ScreenSummary = 'SCREEN_SUMMARY',
    ScreenMagicView = 'SCREEN_MAGIC_VIEW',
    ScreenSummerLimit = 'SCREEN_SUMMER_LIMIT',
    ScreenPracticeEffort = 'SCREEN_PRACTICE_EFFORT',
    ScreenOnlyPlan = 'SCREEN_ONLY_PLAN',
    ScreenProcessing = 'SCREEN_PROCESSING',
    ScreenSeeTheProgress = 'SCREEN_SEE_PROGRESS',
    ScreenEBook = 'SCREEN_E_BOOK',
    TeacherImpact = 'TEACHER_IMPACT',
    ScreenRightTeacher = 'SCREEN_RIGHT_TEACHER',
    TeacherSay = 'STEP_TEACHER_SAY',
    SchoolEfficiency = 'STEP_SCHOOL_EFFICIENCY',
    ScreenMathInMedia = 'SCREEN_MATH_IN_MEDIA',
    ScreenParentsChooseUs = 'SCREEN_PARENTS_CHOOSE_US',
    ChildDistracted = 'STEP_CHILD_DISTRACTED',
    LearningGeneral = 'STEP_LEARNING_GENERAL',
    AdhdDiagnosis = 'STEP_ADHD_DIAGNOSIS',
    SchoolStress = 'STEP_SCHOOL_STRESS',
    AnxietyTriggers = 'STEP_ANXIETY_TRIGGERS',
    MisunderstoodTeachers = 'STEP_MISUNDERSTOOD_TEACHERS',
    HomeworkStruggle = 'STEP_HOMEWORK_STRUGGLE',
    ParentFeelings = 'STEP_PARENT_FEELINGS',
    ChildEngaged = 'STEP_CHILD_ENGAGED',
    HandleFeedback = 'STEP_HANDLE_FEEDBACK',
    DidYouHear = 'STEP_DID_YOU_HEAR',
    EnglishLanguageArts = 'STEP_ENGLISH_LANGUAGE_ARTS',
    AdhdMathConnection = 'STEP_ADHD_MATH_CONNECTION',
    ScreenMathN1Subject = 'SCREEN_MATH_N1_SUBJECT',
    FocusAfterBreak = 'STEP_FOCUS_AFTER_BREAK',
    FallAfterBreak = 'STEP_FALL_AFTER_BREAK',
    ScreenBreakLimit = 'SCREEN_BREAK_LIMIT',
    BreaksAfterStress = 'STEP_BREAKS_AFTER_STRESS',
    StressLowerPerformance = 'STEP_STRESS_LOWER_PERFORMANCE',
    ScreenRegularPractice = 'SCREEN_REGULAR_PRACTICE',
    ScreenHiddenCause = 'SCREEN_HIDDEN_CAUSE',
    ChildAge = 'CHILD_AGE',
    TroubleOrganized = 'TROUBLE_ORGANIZED',
    TiredUnmotivated = 'TIRED_UNMOTIVATED',
    DrainedExhausted = 'DRAINED_EXHAUSTED',
    Headaches = 'HEADACHES',
    LowSelfEsteem = 'LOW_SELF_ESTEEM',
    SadnessAnxiety = 'SADNESS_ANXIETY',
    SleepingIssues = 'SLEEPING_ISSUES',
    StressAffect = 'STRESS_AFFECT',
    WhatStresses = 'WHAT_STRESSES',
    SymptomsAffect = 'SYMPTOMS_AFFECT',
    LastFeel = 'LAST_FEEL',
    MathMostChallenging = 'MATH_MOST_CHALLENGING',
    WhyStrugglesMath = 'WHY_STRUGGLES_MATH',
    MathEffectStress = 'MATH_EFFECT_STRESS',
    ScreenScienceMoment = 'SCREEN_SCIENCE_MOMENT',
    TeacherCauseIssues = 'TEACHER_CAUSE_ISSUES',
    ScreenExpertEducators = 'SCREEN_EXPERT_EDUCATORS',
    PositiveHabits = 'POSITIVE_HABITS',
    QuiteHabits = 'QUITE_HABITS',
    HowMotivated = 'HOW_MOTIVATED',
    ImportantEvent = 'IMPORTANT_EVENT',
    WhenEvent = 'WHEN_EVENT',
    HowMuchTime = 'HOW_MUCH_TIME',
    ScreenKidsJoined = 'SCREEN_KIDS_JOINED',
    CurrentMathLevel = 'STEP_CURRENT_MATH_LEVEL',
    Personality = 'STEP_PERSONALITY',
    LoseInterest = 'LOSE_INTEREST',
    PlanKeySkills = 'PLAN_KEY_SKILLS',
    HowMany = 'STEP_HOW_MANY',
    WantAddEla = 'STEP_WANT_ADD_ELA',
}

export enum QuizMainOnboardingStep {
    ScreenSuccessful = 'SCREEN_SUCCESSFUL',
    ScreenMeetTeacher = 'SCREEN_MEET_TEACHER',
    ScreenAssessmentTest = 'SCREEN_ASSESSMENT_TEST',
    ScreenSucceedMath = 'SCREEN_SUCCEED_MATH',
    ScreenKnowledgeReport = 'SCREEN_KNOWLEDGE_REPORT',
    ScreenJoinClass = 'SCREEN_JOIN_CLASS',
    ScreenTakeLaptop = 'SCREEN_TAKE_LAPTOP',
    ScreenFindEmail = 'SCREEN_FIND_EMAIL',
    ScreenLessonButton = 'SCREEN_LESSON_BUTTON',
    ScreenRecommended = 'SCREEN_RECOMMENDED',
    ScreenGuaranteedGrowth = 'SCREEN_GUARANTEED_GROWTH',
    ScreenTopTutor = 'SCREEN_TOP_TUTOR',
    ScreenAssessmentProcessing = 'SCREEN_ASSESSMENT_PROCESSING',
    ScreenAssessmentCompleted = 'SCREEN_ASSESSMENT_COMPLETED',
    AssessmentFirst = 'ASSESSMENT_FIRST',
    AssessmentSecond = 'ASSESSMENT_SECOND',
    AssessmentThird = 'ASSESSMENT_THIRD',
    AssessmentFourth = 'ASSESSMENT_FOURTH',
}
